/* global VERSION */
require('babel-polyfill')

const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development']

global.APP_CONFIG = global.APP_CONFIG || {}

const api = {
  SCHEME: process.env.API_SCHEME || '',
  HOST: process.env.API_HOST || 'localhost',
  PORT: process.env.API_PORT || 80,
  BASEPATH: process.env.API_BASEPATH || 'api/v1/'
}

const API_URL = `//${api.HOST}${api.PORT !== 80 ? `:${api.PORT}` : ''}/${
  api.BASEPATH
}`
const API_SERVER_URL = API_URL.replace(/\/api\/v1\/?$/, '/')

module.exports = Object.assign(
  global.APP_CONFIG,
  {
    host: process.env.HOST || 'localhost',
    port: process.env.PORT,

    VERSION: typeof VERSION !== 'undefined' && VERSION ? VERSION : '0.0.0',

    FRONTEND_URL: process.env.FRONTEND_URL || '/frontend/',

    API_URL,
    API_SERVER_URL,

    apiVersions: {
      v1: {
        apiScheme: api.SCHEME,
        apiHost: api.HOST,
        apiPort: api.PORT,
        apiBasePath: api.BASEPATH
      }
    },

    plugins: {},

    image: {
      api: {
        url: 'image/:id/',
        version: 'v2'
      }
    },

    item: {
      api: {
        url: 'items/',
        version: 'v1'
      }
    },

    batch: {
      api: {
        url: 'batch/',
        version: 'v2'
      }
    },

    file: {
      api: {
        url: 'file/:id/',
        version: 'v2'
      }
    },

    auth: {
      api: {
        url: 'private/user/:method/',
        version: 'v1',
        actions: {
          impersonate: 'private/user/:id/impersonate',
          stopImpersonate: 'private/user/stop'
        }
      }
    },

    guidedTour: {
      api: {
        url: 'private/me/guidedTour/:id/',
        version: 'v1',
        actions: {
          loadPublic: 'guidedTour/:id/',
          upload: 'private/me/guidedTour/:id/upload/',
          settings: 'private/me/guidedTour/:id/settings/'
        }
      }
    },

    message: {
      api: {
        url: 'private/message/:id/',
        version: 'v1',
        actions: {
          regarding: '/private/message/regarding/:type/:id'
        }
      }
    },

    museum: {
      api: {
        url: 'private/museum/:id/',
        version: 'v1',
        actions: {
          loadPublic: 'museum/:id/',
          upload: 'private/museum/:id/upload/',
          crypto: 'museum/crypto/:cryptoId'
        }
      }
    },

    rating: {
      api: {
        url: 'private/rating/:id/',
        version: 'v1',
        actions: {
          loadPublic: 'rating/:id/',
          upload: 'private/rating/:id/upload/'
        }
      }
    },

    program: {
      api: {
        url: 'private/me/program/:id/',
        version: 'v1',
        actions: {
          loadPublic: 'program/:id/',
          upload: 'private/me/program/:id/upload/',
          settings: 'private/me/program/:id/settings/'
        }
      }
    },

    user: {
      api: {
        url: 'private/user/:id/',
        version: 'v1'
      }
    },

    release: {
      api: {
        url: 'private/release/:id/',
        version: 'v1'
      }
    },

    settings: {
      api: {
        url: 'private/settings/',
        version: 'v1',
        actions: {
          add: 'private/settings/:list/',
          remove: 'private/settings/:list/:id'
        }
      }
    },

    app: {
      title: 'Musbi',
      description: 'Musbi.',
      head: {
        titleTemplate: 'Musbi: %s',
        meta: [
          { name: 'description', content: 'Musbi.' },
          { charset: 'utf-8' },
          { property: 'og:site_name', content: 'Musbi' },
          { property: 'og:image', content: '' },
          { property: 'og:locale', content: 'de_DE' },
          { property: 'og:title', content: 'Musbi' },
          { property: 'og:description', content: 'Musbi.' },
          { property: 'og:card', content: 'summary' },
          { property: 'og:site', content: '@musbi' },
          { property: 'og:creator', content: '@musbi' },
          { property: 'og:image:width', content: '200' },
          { property: 'og:image:height', content: '200' }
        ]
      }
    }
  },
  environment
)



// WEBPACK FOOTER //
// ./src/config/index.js